<template>
    <div class="user-detail-layout">
        <div class="user-detail-top">
            <a-row :gutter="16">
                <!-- 帳號等級 -->
                <a-col :span="6">
                    <div class="top-col user-grade-box"
                        :class="userInfo.team_id ? memberTypeList[3].bg_class : memberTypeList[userInfo.level].bg_class">
                        <div class="grade-top">
                            <img class="grade-icon"
                                :src="userInfo.team_id ? memberTypeList[3].src : memberTypeList[userInfo.level].src" />
                            <div class="contents">
                                <h1>{{ userInfo.team_id ? memberTypeList[3].name :
                                    memberTypeList[userInfo.level].name }}</h1>
                                <span v-if="userInfo.team_id || (userInfo.team_id == 0 && userInfo.level > 0)">{{
                                    teamUserInfo.expire_time_text }}{{ $t('enum.userOther.overdue') }}</span>
                            </div>
                        </div>
                        <div class="grade-bottom">
                            <span class="names">{{ userInfo.name }}</span>
                            <a-button @click="renewalEvent"
                                v-if="(userInfo.team_id && userInfo.is_team_admin) || (userInfo.team_id == 0 && userInfo.level)">
                                {{ $t('enum.payConfigType.1') }}
                            </a-button>
                        </div>
                    </div>
                </a-col>
                <!-- 帳號其他 -->
                <a-col :span="6">
                    <div class="top-col user-detail-other">
                        <div class="top">
                            <h1>{{ userInfo.phone }}</h1>
                            <h5>{{ userInfo.address }}</h5>
                        </div>
                        <div class="bottom">
                            <span>{{ arrangeTime(userInfo.create_time) }}{{ $t('enum.userOther.create') }}</span>
                            <div class="btns">
                                <a-button type="primary" v-if="userInfo.team_id == 0 && userInfo.level < 2"
                                    @click="changePackage('upgrade')" >{{
                                        $t('enum.payConfigType.4') }}
                                </a-button>
                                <a-button type="primary" v-if="userInfo.team_id == 0 && packageList.length"
                                    @click="changePackage('package')" >
                                    {{ $t('enum.payConfigType.5') }}
                                </a-button>
                                <a-button type="primary"
                                    v-if="userInfo.team_id && userInfo.is_team_admin || userInfo.team_id == 0"
                                    @click="changePackage('camera')" >{{
                                        $t('enum.payConfigType.6') }}
                                </a-button>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 帳號容量 -->
                <a-col :span="6">
                    <div class="top-col volume-box">
                        <div class="top">
                            <h1>{{ $t("descriptions.totalSpaceCapacity") }}</h1>
                        </div>
                        <div class="bottom">
                            <div class="lists" v-if="userInfo.team_id">
                                <span class="nums">
                                    <span class="tips">{{ userInfo.now_num }}人</span>/{{ userInfo.limit_num }}人
                                </span>
                                <a-progress :percent="(userInfo.now_num / userInfo.limit_num) * 100" :show-info="false" />
                                <a-button v-if="userInfo.is_team_admin" @click="changePackage('team')">
                                    {{ $t('enum.payConfigType.3') }}
                                </a-button>
                            </div>
                            <div class="lists">
                                <span class="nums">
                                    <span class="tips">{{ teamUserInfo.use_capacity }}G</span>/{{ teamUserInfo.capacity }}G
                                </span>
                                <a-progress :percent="teamUserInfo.capacity_ratio" :show-info="false" />
                                <a-button
                                    v-if="(userInfo.team_id && userInfo.is_team_admin) || (userInfo.team_id == 0 && userInfo.level)"
                                    @click="changePackage('volume')">
                                    {{ $t('enum.payConfigType.2') }}
                                </a-button>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 3D 模型屋升級 -->
                <a-col :span="6">
                    <div class="top-col model-house">
                        <div class="top">
                            <h1>{{ $t("descriptions.modelHouse") }}</h1>
                        </div>
                        <div class="bottom">
                            <div class="leftElement">
                                <img class="pIcon" src="@/assets/picon.png">
                                <span class="remainingPoints"><strong>{{ $t('enum.modelOther.points') }}</strong></span>
                                <span class="pointData" >{{ userInfo.point }}點</span>
                            </div>
                            <a-button @click="changePackage('purchase')">{{ $t('enum.payConfigType.7') }}</a-button>
                        </div>
                    </div>
                </a-col>
            </a-row>
            <!-- 支付返回的html -->
            <div class="payForm" v-show="false" v-html="payHtml"></div>
        </div>

        <!-- 修改帳號信息相關 -->
        <div class="user-detail-info">
            <a-card :title="$t(`moduleTitles.${$route.meta.title}`)" :bordered="false">
                <a-row>
                    <a-col :span="12">
                        <a-form-model layout="vertical" ref="ruleForm" :form="accountInfo" :rules="rules"
                            :model="accountInfo">
                            <!-- 帳號 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.account.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <a-input v-model="accountInfo.phone" :disabled="true" />
                            </a-form-model-item>
                            <!-- 個人的暱稱 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.name.label') + '：'" prop="name"
                                v-if="userInfo.team_id == 0">
                                <a-input v-model="accountInfo.name" />
                            </a-form-model-item>
                            <!-- 水印 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.waterMark.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <span slot="label">{{ $t("form.common.field.waterMark.label") }}</span>
                                <div style="height: 100%">
                                    <div style="margin-bottom: 5px;width: 160px;background:#333;"
                                        v-show="accountInfo.water_logo">
                                        <img :src="accountInfo.water_logo" width="100%" height="100%" />
                                    </div>
                                    <DragUploader ref="wateruploader" uptype="logo" :callback="watergetUploader"
                                        style="display:inline-block;margin-right:10px;">
                                        <a-button type="primary" slot="body" >{{
                                            $t("message.uploadBtn")
                                        }}</a-button>
                                    </DragUploader>
                                    <span>{{ $t("message.picture") }}</span>
                                </div>
                            </a-form-model-item>
                            <!-- 性別 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.gender.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <a-radio-group v-model="accountInfo.gender">
                                    <a-radio :value="1">{{ $t('enum.gender.male')
                                    }}</a-radio>
                                    <a-radio :value="0">{{ $t('enum.gender.female')
                                    }}</a-radio>
                                </a-radio-group>
                            </a-form-model-item>
                            <!-- 所在地區 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.area.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <h-region-select @regionData="selectedData" :defaultValue="defaultValue"></h-region-select>
                            </a-form-model-item>
                            <!-- 簡介 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.briefIntroduction.label')"
                                v-if="userInfo.team_id == 0">
                                <a-textarea v-model="accountInfo.brief"
                                    :placeholder="$t('form.common.field.briefIntroduction.placeholder')" allow-clear />
                            </a-form-model-item>
                            <!-- 地址 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.address.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <a-textarea v-model="accountInfo.address"
                                    :placeholder="$t('form.common.field.address.message')" allow-clear />
                            </a-form-model-item>
                            <!-- 個人的聯繫電話 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.mobile.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <a-input v-model="accountInfo.tel" :placeholder="$t('form.common.field.mobile.message')" />
                            </a-form-model-item>
                            <!-- line帳號 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.wechat.label') + '：'"
                                v-if="userInfo.team_id == 0">
                                <a-input v-model="accountInfo.wechat"
                                    :placeholder="$t('form.common.field.wechat.message')" />
                            </a-form-model-item>

                            <!------------------------- 團隊和個人的分割線--------------------------->

                            <!-- 團隊中的暱稱 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.name.label') + '：'"
                                prop="user_team_name" v-if="userInfo.team_id">
                                <a-input v-model="accountInfo.user_team_name" />
                            </a-form-model-item>
                            <!-- 團隊的聯繫電話 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.mobile.label') + '：'"
                                v-if="userInfo.team_id">
                                <a-input v-model="accountInfo.phone" :placeholder="$t('form.common.field.mobile.message')"
                                    :disabled="true" />
                            </a-form-model-item>
                            <!-- line帳號 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.wechat.label') + '：'"
                                v-if="userInfo.team_id">
                                <a-input v-model="accountInfo.line_account"
                                    :placeholder="$t('form.common.field.wechat.message')" />
                            </a-form-model-item>
                            <!-- e-mail郵箱 ------------------公用----------->
                            <a-form-model-item has-feedback :label="$t('form.common.field.email.label') + '：'">
                                <a-input v-model="accountInfo.email" :placeholder="$t('form.common.field.email.message')" />
                            </a-form-model-item>
                            <!-- 職位 -->
                            <a-form-model-item has-feedback :label="$t('form.common.field.position.label') + '：'"
                                v-if="userInfo.team_id">
                                <a-tag v-for="(item, index) in jobList" :key="index"
                                    :color="accountInfo.position == item ? '#108ee9' : ''" @click="changePosition(item)">
                                    {{ item }}
                                </a-tag>
                            </a-form-model-item>
                            <!-- 按鈕 -->
                            <a-form-model-item>
                                <a-button type="primary" @click="handleSubmit" >{{
                                    $t('actionTitles.submit') }}</a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </a-col>
                    <!--右側頭像-->
                    <a-col :span="12">
                        <div style="text-align: center;">
                            <div class="avatar">
                                <img :src="accountInfo.avatar ? accountInfo.avatar : avatar" width="100%" height="100%"
                                    alt="avatar" />
                            </div>
                            <DragUploader ref="uploader" uptype="avatar" :callback="getUploader">
                                <a-button type="primary" slot="body" >{{
                                    $t('actionTitles.avatarUpload') }}</a-button>
                            </DragUploader>
                        </div>
                    </a-col>
                </a-row>
            </a-card>
        </div>

        <!-- 套餐彈出框 -->
        <a-modal :visible="packageVisible" :destroyOnClose="true" :width="680" :title="packageTypeTitle"
            @cancel="closePackageModal" :footer="null">
            <div class="package-modal-box">
                <div class="lists" v-for="(item, index) in selectPackageTypeList" :key="index">
                    <div class="icon-box" :style="{ backgroundImage: 'url(' + getPackageBg(item, index) + ')' }">
                        <h1>{{ item.icon_top_text }}</h1>
                        <span></span>
                        <h5>{{ item.icon_bottom_text }}</h5>
                    </div>
                    <div class="info-box">
                        <img class="pIcon" v-if="currPackageType === 'purchase'" src="@/assets/picon.png">
                        <h1 class="title">{{ item.name }}</h1>
                        <h5 class="info">{{ item.description }}</h5>
                        <p class="" v-if="currPackageType == 'upgrade'">{{ $t('member.monthly') }}
                            {{ item.one_month_amount }}{{ $t('member.amountUnit') }} <span class="sm-text">({{
                                $t('member.NT') }}.{{ item.amount }})</span></p>
                        <p class="" v-if="currPackageType == 'package'">{{ $t('member.specials') }}
                            {{ item.amount }}{{ $t('member.amountUnit') }} <span class="sm-text">/{{ $t('member.year')
                            }}</span>
                        </p>
                        <p class=""
                            v-if="currPackageType == 'volume' || currPackageType == 'team' || currPackageType == 'camera' || currPackageType == 'purchase'">
                            {{ $t('member.NT$') }} {{ item.amount }}{{ $t('member.amountUnit') }}</p>
                    </div>
                    <div class="emendation-box"
                        v-if="currPackageType == 'volume' || currPackageType == 'team' || currPackageType == 'purchase'">
                        <div class="btns" @click="onChangeAddValueNumber('-', index)">
                            <a-icon type="minus" />
                        </div>
                        <div class="nums">{{ item.buy_num }}</div>
                        <div class="btns" @click="onChangeAddValueNumber('+', index)">
                            <a-icon type="plus" />
                        </div>
                    </div>
                    <div class="btns-box">
                        <a-button type="primary" v-if="currPackageType == 'upgrade'"
                            @click="selectPackageEvent(item, getPackageBg(item, index))"
                            >{{ $t('member.upgradeBtn') }}
                        </a-button>
                        <a-button type="primary" v-else-if="currPackageType == 'volume' || currPackageType == 'team'"
                            @click="selectPackageEvent(item, getPackageBg(item, index))"
                            >{{ $t('member.addBtn') }}
                        </a-button>
                        <a-button type="primary" v-else @click="selectPackageEvent(item, getPackageBg(item, index))"
                            >{{
                                $t('member.buyBtn') }}
                        </a-button>
                    </div>
                </div>
            </div>
        </a-modal>

        <!-- 支付彈窗 -->
        <a-modal :visible="payVisible" :destroyOnClose="true" :width="600" :title="$t('member.payment')" :footer="null"
            @cancel="closePayModal">
            <div class="pay-wrap">
                <div class="top">
                    <div class="icon-box" :style="{ backgroundImage: 'url(' + payItem.type + ')' }">
                        <h1>{{ payItem.item.icon_top_text }}</h1>
                        <span></span>
                        <h5>{{ payItem.item.icon_bottom_text }}</h5>
                    </div>
                    <div class="info-box">
                        <img class="pIcon" v-if="currPackageType === 'purchase'" src="@/assets/picon.png">
                        <h1>{{ payItem.item.name }}</h1>
                        <h5>{{ payItem.item.description }}</h5>
                    </div>
                    <!-- 另選套餐 -->
                    <div class="other-btn" v-if="payItem.otherShow && currStep == 0" @click="switchPayData">
                        {{ $t('member.changePackage') }}</div>
                </div>
                <div class="amount-box">{{ $t('member.total') }}：{{ $t('member.NT') }}<span class="amounts">{{
                    payItem.amount }}</span>{{ $t('member.amountUnit') }}</div>
                <a-steps :current="currStep" size="small">
                    <a-step :title="$t('member.step.0')" />
                    <a-step :title="$t('member.step.1')" />
                    <a-step :title="$t('member.step.2')" />
                </a-steps>
                <div class="contents-box" v-if="currStep == 0">
                    <div class="pay-title">
                        <a-icon type="wallet" />
                        {{ $t('form.pay.field.payType.label') }}
                    </div>
                    <a-row :gutter="20">
                        <a-col :span="8" v-for="(item, index) in newPayList" :key="item.id">
                            <div class="pay-type-list" @click="selectPayType(item)"
                                :class="currPayType.id == item.id ? 'active' : ''">
                                {{ item.type_text }}
                                <span class="texts" v-if="item.installment_text != ''">({{ item.installment_text }})</span>
                                <span class="btns" v-if="item.interest != '0.00'">{{ item.interest }}%</span>
                            </div>
                        </a-col>
                    </a-row>
                    <a-form-model ref="receivingForm" :model="payData" :rules="receivingRules" :label-col="labelCol"
                        :wrapper-col="wrapperCol" v-if="payItem.item.camera_type > 0">
                        <a-form-model-item :label="$t('form.receiving.name.label')" prop="name">
                            <a-input :placeholder="$t('form.receiving.name.placeholder')" v-model="payData.name" />
                        </a-form-model-item>
                        <a-form-model-item :label="$t('form.receiving.phone.label')" prop="phone">
                            <a-input :placeholder="$t('form.receiving.phone.placeholder')" v-model="payData.phone" />
                        </a-form-model-item>
                        <a-form-model-item :label="$t('form.receiving.address.label')" prop="address">
                            <a-input :placeholder="$t('form.receiving.address.placeholder')" v-model="payData.address" />
                        </a-form-model-item>
                    </a-form-model>
                    <div class="bottom">
                        <div class="texts">{{ $t('form.pay.payCount') }} {{ $t('member.NT') }}<span class="amount">{{
                            totalAmount(payItem.amount) }}</span>{{ $t('member.amountUnit') }}</div>
                        <a-button type="primary" @click="nextStep">{{
                            $t('actionTitles.next') }}</a-button>
                    </div>
                </div>
                <div class="contents-box" v-if="currStep == 1">
                    <div class="pay-title">
                        <a-icon type="file" />
                        {{ $t('form.invoice.information') }}
                    </div>
                    <a-form-model ref="invoiceForm" :model="payData" :rules="receivingRules" :label-col="labelCol"
                        :wrapper-col="wrapperCol">
                        <a-form-model-item :label="$t('form.invoice.invoiceType')">
                            <a-select :value="payData.invoiceType" style="width: 200px" @change="changePayInvoiceType">
                                <a-select-option :key="1">{{ $t('form.team.personal') }}</a-select-option>
                                <a-select-option :key="2">{{ $t('form.team.company') }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item :label="$t('form.invoice.head.label')" prop="companyName"
                            v-if="payData.invoiceType == 2">
                            <a-input :placeholder="$t('form.invoice.head.placeholder')" v-model="payData.companyName" />
                        </a-form-model-item>
                        <a-form-model-item :label="$t('form.invoice.code.label')" prop="companyNo"
                            v-if="payData.invoiceType == 2">
                            <a-input :placeholder="$t('form.invoice.code.placeholder')" v-model="payData.companyNo" />
                        </a-form-model-item>
                        <a-form-model-item :label="$t('form.invoice.email.label')" prop="email">
                            <a-input :placeholder="$t('form.invoice.email.placeholder')" v-model="payData.email" />
                        </a-form-model-item>
                    </a-form-model>
                    <div class="bottom">
                        <div class="texts">{{ $t('form.invoice.tip.0') }}<br />{{ $t('form.invoice.tip.1') }}</div>
                        <div class="btns">
                            <a-button @click="currStep = 0">{{ $t('actionTitles.prev') }}</a-button>
                            <a-button type="primary" @click="submitPay" :loading="btnLoading"
                                >{{ $t('actionTitles.next')
                                }}</a-button>
                        </div>
                    </div>
                </div>
                <div class="contents-box last-step" v-if="currStep == 2">
                    <div class="amount-boxs">
                        {{ $t('form.pay.payCount') }}： {{ $t('member.NT') }}<span class="amount">{{
                            totalAmount(payItem.amount) }}</span>{{ $t('member.amountUnit') }}
                    </div>
                    <div class="btns">
                        <a-button @click="currStep = 1">{{ $t('actionTitles.prev') }}</a-button>
                        <a-button type="primary" class="pay-btn" @click="payFormSubmit"
                            >{{ $t('actionTitles.payConfirm')
                            }}</a-button>
                    </div>
                </div>
            </div>
        </a-modal>

        <!-- 支付結果 -->
        <a-modal :visible="payResultsVisible" :destroyOnClose="true" :width="500" :title="$t('form.pay.paySure')"
            :footer="null">
            <div class="pay-result-box">
                <div class="content">{{ $t('form.pay.paySureText') }}</div>
                <div class="btns">
                    <a-button type="primary" class="sure-btn" @click="surePayResult">
                        {{ $t('form.pay.payFinish')}}
                    </a-button>
                </div>
                <div class="tips">{{ $t('form.pay.payError') }}：{{ siteInfo.phone }}</div>
            </div>
        </a-modal>

    </div>
</template>
<script>
import HRegionSelect from "@/components/HRegionSelect";
import DragUploader from "@/components/DragUploader";
import { mapState } from "vuex";
import { getUserInfo, updateUserInfo } from "@/api/user";
import { getMemberInfo, getUserRenewal, getInstalmentList, getPayToken } from "@/api/member";
import { editUserTeamInfo, getTeamDetail } from "@/api/team";



const payDefalutItem = {
    item: {},
    type: '',
    amount: 0
}
const payDefaultData = {
    name: '',
    phone: '',
    address: '',
    email: '',
    invoiceTitle: '個人',//1-個人，2-公司
    invoiceType: 1,
    companyName: '',
    companyNo: '',
}

export default {
    components: {
        HRegionSelect,
        DragUploader,
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.user.userInfo,
            siteInfo: (state) => state.siteConfig.siteInfo,
        }),
        newPayList() {
            let list = []
            if (this.payItem.item.is_instalment == 0) {
                this.payList.forEach(obj => {
                    if (obj.installment_num == 0) {
                        list.push(obj)
                    }
                })
            } else {
                list = JSON.parse(JSON.stringify(this.payList))
            }
            return list
        },
    },
    data() {
        return {
            avatar: require('@/assets/default_h.jpg'),
            defaultValue: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$t("form.common.field.name.message"),
                        trigger: "blur",
                    },
                ],
                user_team_name: [
                    {
                        required: true,
                        message: this.$t("form.common.field.name.message"),
                        trigger: "blur",
                    },
                ]
            },
            //帳戶信息
            accountInfo: {},
            //升級解鎖list
            upgradeList: [],
            //容量加值list
            volumeList: [],
            //團隊加值list
            teamList: [],
            //套餐方案list
            packageList: [],
            //加購相機list
            cameraList: [],
            // 加購點數list
            pointList: [],
            teamUserInfo: {},

            memberTypeList: [
                { src: require('@/assets/img/member_icon_1.png'), name: this.$t('enum.userLevel.0'), bg_class: 'level_1' },
                { src: require('@/assets/img/member_icon_2.png'), name: this.$t('enum.userLevel.1'), bg_class: 'level_2' },
                { src: require('@/assets/img/member_icon_3.png'), name: this.$t('enum.userLevel.2'), bg_class: 'level_3' },
                { src: require('@/assets/img/member_icon_4.png'), name: this.$t('enum.userLevel.3'), bg_class: 'level_4' },
            ],
            jobList: [
                '老闆/總監',
                '設計師',
                '項目經理',
                '工頭',
                '銷售/市場',
                '客服經理',
                '工長',
                '水電工',
                '其他',
            ],

            packageVisible: false,
            packageTypeTitle: '',
            currPackageType: '',
            selectPackageTypeList: [],
            selectPackage: {
                item: {},
                type: '',
                amount: 0
            },
            //其他套餐所需要的背景圖和小背景
            otherList: {
                level_1: { icon: require('@/assets/img/member_list_1.png') },
                level_2: { icon: require('@/assets/img/member_list_2.png') },
                level_3: { icon: require('@/assets/img/member_list_3.png') },
                camera: { icon: require('@/assets/img/member_list_4.png') },
                team_0: { icon: require('@/assets/img/member_list_5.png') },
                team_1: { icon: require('@/assets/img/member_list_6.png') },
                team_2: { icon: require('@/assets/img/member_list_7.png') },
                capacity: { icon: require('@/assets/img/member_list_8.png') },
                points_0: { icon: require('@/assets/img/member_list_2.png') },
                points_1: { icon: require('@/assets/img/member_list_5.png') },
                points_2: { icon: require('@/assets/img/member_list_7.png') },
            },

            otherConfigData: {},
            payConfigData: {},

            payVisible: false,
            payItem: {
                item: {},
                amount: '',
                type: '',
            },
            payList: [],
            payData: {
                name: '',
                phone: '',
                address: '',
                email: '',
                invoiceTitle: '',//1-個人，2-公司
                invoiceType: 1,
                companyName: '',
                companyNo: '',
            },
            currPayType: {},
            receivingRules: {
                name: [
                    {
                        required: true,
                        message: this.$t('form.receiving.name.message'),
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: this.$t('form.receiving.phone.message'),
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: this.$t('form.receiving.address.message'),
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: this.$t('form.invoice.email.message'),
                        trigger: "blur",
                    },
                ],
                companyName: [
                    {
                        required: true,
                        message: this.$t('form.invoice.head.message'),
                        trigger: "blur",
                    },
                ],
                companyNo: [
                    {
                        required: true,
                        message: this.$t('form.invoice.code.message'),
                        trigger: "blur",
                    },
                ],
            },
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            currStep: 0,

            payHtml: '',
            btnLoading: false,

            payResultsVisible: false,
        };
    },
    mounted() {
        const changeTeam = this.$route.params && this.$route.params.change_team
        if (changeTeam) {
            window.location.reload();
        }
        if (this.userInfo.team_id) {
            this.getTeamDetail()
        } else {
            this.getUserInfo()
        }
        this.getMemberInfo()
        this.getInstalmentList()
    },
    methods: {
        //是團隊帳號獲取相關帳號信息
        getTeamDetail() {
            getTeamDetail().then((res) => {
                if (res.code) {
                    this.accountInfo = res.data.user_team_info
                    console.log('accountInfo團隊帳號信息', this.accountInfo)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        //是個人帳號獲取相關帳號信息
        getUserInfo() {
            getUserInfo().then((res) => {
                if (res.code) {
                    this.accountInfo = res.data;
                    console.log('accountInfo個人帳號信息', this.accountInfo)
                    this.defaultValue = res.data.parent_regoin;
                }
            });
        },
        //獲取套餐等
        getMemberInfo() {
            getMemberInfo().then(res => {
                if (res.code == 1) {
                    this.upgradeList = res.data.upgradeList
                    this.cameraList = res.data.cameraList
                    this.packageList = res.data.packageList
                    this.teamList = res.data.teamList
                    this.volumeList = res.data.volumeList
                    this.teamUserInfo = res.data.userInfo
                    this.pointList = res.data.pointList
                }
            }).catch(err => {
                console.log(err)
            })
        },
        //提交方法保存
        handleSubmit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (this.userInfo.team_id == 0) {
                        this.updateUserInfo()
                    } else {
                        this.editUserTeamInfo()
                    }
                }
            });
        },
        //個人帳號保存信息
        updateUserInfo() {
            updateUserInfo(this.accountInfo).then((res) => {
                this.$message.success(this.$i18n.t("message.saveSuccess"));
                this.$store.dispatch("getUserInfo", this.accountInfo);
            }).catch(err => {
                console.log(err)
            });
        },
        //團隊帳號保存信息
        editUserTeamInfo() {
            editUserTeamInfo(this.accountInfo).then(res => {
                this.$message.success(this.$i18n.t("message.saveSuccess"));
                this.$store.dispatch("getUserInfo", this.accountInfo);
            }).catch(err => {
                console.log(err)
            });
        },
        //選擇所在地區
        selectedData(val) {
            this.accountInfo.region = val;
        },
        //回調方法，up為上傳實例對像
        getUploader: function (up) {
            let _this = this;
            _this.$nextTick(() => {
                up.bind("UploadComplete", function (up, file) {
                    _this.accountInfo.avatar = _this.$refs.uploader.fileList[0].url;
                });
            });
        },
        //整理時間
        arrangeTime(time) {
            return time.substring(0, 11);
        },
        //切換職位
        changePosition(item) {
            this.accountInfo.position = item
        },

        //選擇不同套餐
        changePackage(type) {
            this.currPackageType = type
            switch (type) {
                case 'upgrade':
                    this.selectPackageTypeList = JSON.parse(JSON.stringify(this.upgradeList))
                    this.packageTypeTitle = this.$t('enum.payConfigType.4')
                    break;
                case 'volume':
                    this.selectPackageTypeList = JSON.parse(JSON.stringify(this.volumeList))
                    this.selectPackageTypeList.forEach(obj => {
                        obj.buy_num = 1
                    })
                    this.packageTypeTitle = this.$t('enum.payConfigType.2')
                    break;
                case 'team':
                    this.selectPackageTypeList = JSON.parse(JSON.stringify(this.teamList))
                    this.selectPackageTypeList.forEach(obj => {
                        obj.buy_num = 1
                    })
                    this.packageTypeTitle = this.$t('enum.payConfigType.3')
                    break;
                case 'package':
                    this.selectPackageTypeList = JSON.parse(JSON.stringify(this.packageList))
                    this.packageTypeTitle = this.$t('enum.payConfigType.5')
                    break;
                case 'camera':
                    this.selectPackageTypeList = JSON.parse(JSON.stringify(this.cameraList))
                    this.packageTypeTitle = this.$t('enum.payConfigType.6')
                    break;
                case 'purchase':
                    this.selectPackageTypeList = JSON.parse(JSON.stringify(this.pointList))
                    this.selectPackageTypeList.forEach(obj => {
                        obj.buy_num = 1;
                    })
                    this.packageTypeTitle = this.$t('enum.payConfigType.7')
                    break;
            }
            this.packageVisible = true
        },
        //獲取不同的套餐背景
        getPackageBg(item, index) {
            let url = '';
            console.log('currPackageType:', this.currPackageType);
            console.log('index:', index);
            switch (this.currPackageType) {
                case 'upgrade':
                    url = this.otherList['level_' + item.user_level].icon
                    break;
                case 'volume':
                    url = index < 3 ? this.otherList['team_' + index].icon : this.otherList['capacity'].icon
                    break;
                case 'team':
                    url = index < 3 ? this.otherList['team_' + index].icon : this.otherList['capacity'].icon
                    break;
                case 'package':
                    url = this.otherList['level_' + item.user_level].icon
                    break;
                case 'camera':
                    url = this.otherList['camera'].icon
                    break;
                case 'purchase':
                    url = index < 3 ? this.otherList['points_' + index].icon : this.otherList['capacity'].icon
                    break;
            }
            console.log('Selected URL:', url);
            return url
        },
        //選擇套餐
        selectPackageEvent(item, type) {
            this.selectPackage.item = item
            this.selectPackage.type = type
            this.selectPackage.amount = item.hasOwnProperty("buy_num") ? item.amount * item.buy_num : item.amount

            this.showPay(this.selectPackage);
        },
        //關閉套餐彈出
        closePackageModal() {
            this.selectPackage = payDefalutItem
            this.selectPackageTypeList = []
            this.packageVisible = false
        },
        //切換加值的數量
        onChangeAddValueNumber(type, index) {
            let num = this.selectPackageTypeList[index].buy_num
            if (type == '+') {
                num++
            } else {
                if (num <= 1) {
                    this.$message.error(this.$t('member.numOver'))
                } else {
                    num--
                }
            }
            this.$set(this.selectPackageTypeList[index], 'buy_num', num)
            this.$forceUpdate();
        },

        //續費
        renewalEvent() {
            getUserRenewal().then(res => {
                if (res.code == 1) {
                    this.payConfigData = res.data.payConfigData;
                    this.otherConfigData = res.data.otherConfigData;
                    const otherShow = (this.otherConfigData && this.otherConfigData.id)
                    let data = {
                        item: this.payConfigData,
                        type: this.otherList['level_' + this.payConfigData.user_level].icon,
                        amount: this.payConfigData.amount,
                        otherShow: otherShow
                    }
                    this.showPay(data)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        //另選套餐
        switchPayData() {
            if (this.payItem.otherShow) {
                let item = this.payItem.item.id === this.payConfigData.id ? this.otherConfigData : this.payConfigData
                this.$set(this.payItem, 'item', item);
                this.$set(this.payItem, 'amount', item.amount);
                // console.log('另選套餐', this.payItem);
                // console.log('另選套餐', item);
            }
        },
        //獲取支付方式
        getInstalmentList() {
            getInstalmentList().then(res => {
                if (res.code == 1) {
                    this.payList = res.data
                }
            }).catch(err => {
                console.log(err)
            })
        },
        //支付彈出框顯示
        showPay(item) {
            this.payItem = JSON.parse(JSON.stringify(item))
            this.payVisible = true
            this.closePackageModal()
            console.log('this.payItem', this.payItem)
        },
        //選擇支付方式
        selectPayType(item) {
            this.currPayType = item
        },
        //計算總額
        totalAmount(amount) {
            let total = Number(amount);
            const percent = Number(this.currPayType.interest)
            if (!isNaN(percent) && !isNaN(total)) {
                let newTotal = total + (total * percent / 100);
                total = newTotal.toFixed();
            }
            return total
        },
        //下一步
        nextStep() {
            if (Object.keys(this.currPayType).length === 0) {
                this.$message.error(this.$t('form.pay.field.payType.message'), 1)
                return
            }
            if (this.currPayType.id == 5 && Number(this.payItem.amount) > 49999) {
                this.$message.error(this.$t('form.pay.field.payType.amountMsg'), 1)
                return
            }
            if (this.payItem.item.camera_type > 0) {
                this.$refs.receivingForm.validate((valid) => {
                    if (valid) {
                        this.currStep = 1
                    }
                });
            } else {
                this.currStep = 1
            }
        },
        //切換發票類型
        changePayInvoiceType(e) {
            this.payData.invoiceType = e
            this.$refs.invoiceForm.resetFields();
        },
        //送出
        submitPay() {
            this.$refs.invoiceForm.validate((valid) => {
                if (valid) {
                    let address = {}
                    if (this.payItem.item && this.payItem.item.camera_type > 0) {
                        address = {
                            name: this.payData.name,
                            phone: this.payData.phone,
                            address: this.payData.address
                        }
                    }
                    const invoice_consultation = {
                        type: this.payData.invoiceType,//1私人 2公司
                        email: this.payData.email,
                        identifier: this.payData.companyNo,
                        company_name: this.payData.companyName,
                    }
                    const params = {
                        pay_method: "ecpay_web",
                        pay_config_id: this.payItem.item.id,
                        buy_num: this.payItem.item.buy_num,
                        instalment_id: this.currPayType.id,
                        address,
                        invoice_consultation
                    }
                    console.log('====get token params====', params)
                    this.btnLoading = true
                    getPayToken(params).then(res => {
                        if (res.code == 1) {
                            this.payHtml = res.data
                            this.btnLoading = false
                            this.currStep = 2
                        }
                    }).catch(err => {
                        console.log(err)
                        this.btnLoading = false
                    })
                }
            });
        },
        //關閉支付彈窗
        closePayModal() {
            this.payVisible = false
            setTimeout(() => {
                this.payItem = payDefalutItem
                this.currPayType = {}
                this.currStep = 0
                this.payData = payDefaultData
            }, 1000)
        },
        //支付
        payFormSubmit() {
            $(".payForm form").submit();
            this.closePayModal()
            this.payResultsVisible = true
        },
        //確認結果
        surePayResult() {
            this.payResultsVisible = false
            setTimeout(() => {
                window.location.reload();
            }, 1000)
        },
        watergetUploader(up) {
            let _this = this;
            _this.$nextTick(() => {
                up.bind("UploadComplete", function (up, file) {
                    _this.accountInfo.water_logo = _this.$refs.wateruploader.fileList[0].url;
                });
            });
        },

    },
};
</script>

<style lang="less" scoped>
.avatar {
    margin-bottom: 25px;
}

.specialBtn {
    background-color: #7101ad;
    border-color: #7101ad;
}

.specialBtn:hover {
    background-color: #d485ff;
    border-color: #d485ff;
}

.specialBtn:focus {
    background-color: #d485ff;
    border-color: #d485ff;
}

.avatar img {
    border-radius: 167px;
    width: 167px;
    height: 167px;
}

.user-detail-top {
    .top-col {
        background-color: #ffffff;
        border-radius: 5px;
        height: 160px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .user-grade-box {

        &.level_1 {}

        &.level_2 {
            background-image: linear-gradient(to bottom, #bce8f0, #66b4c1);

            .grade-top {
                .contents {
                    h1 {
                        color: #015C61;
                    }
                }
            }
        }

        &.level_3 {
            background-image: linear-gradient(to bottom, #e0c89a, #bc9c5c);

            .grade-top {
                .contents {
                    h1 {
                        color: #5C4B1D;
                    }
                }
            }
        }

        &.level_4 {
            background-image: linear-gradient(to bottom, #686463, #1d0f0d);

            .grade-top {
                .contents {
                    h1 {
                        color: #ffffff;
                    }

                    span {
                        color: #ffffff;
                    }
                }
            }

            .grade-bottom {
                .names {
                    color: #fff;
                }
            }
        }

        .grade-top {
            display: flex;
            align-items: center;

            .grade-icon {
                width: 60px;
                height: 60px;
                flex-shrink: 0;
                margin-right: 10px;
            }

            .contents {
                h1 {
                    font-size: 20px;
                    font-weight: bold;
                    margin-bottom: 0;
                    color: #848484;
                }

                span {
                    font-size: 14px;
                    color: #000;
                }
            }
        }

        .grade-bottom {
            display: flex;
            align-items: flex-end;
            height: 50px;
            justify-content: space-between;
        }
    }

    .user-detail-other {
        color: #000;

        .top {
            h1 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 2px;
            }

            h5 {
                font-size: 14px;
            }
        }

        .bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            &>span {
                color: #000;
                font-size: 14px;
                flex-shrink: 0;
            }

            .btns {
                display: flex;
                align-items: center;

                /deep/ .ant-btn {
                    margin-left: 10px;

                    &:first-child {
                        margin-left: 0;
                    }
                }

                .specialBtn {
                    background-color: #7101ad;
                    border-color: #7101ad;
                }
            }
        }
    }

    .volume-box {
        .top {
            color: #000;

            h1 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 2px;
            }
        }

        .bottom {
            .lists {
                display: flex;
                align-items: center;
                justify-content: space-around;
                margin-top: 10px;

                .nums {
                    flex-shrink: 0;
                    margin-right: 20px;

                    .tips {
                        color: #0d95e8;
                    }
                }

                /deep/ .ant-btn {
                    flex-shrink: 0;
                    margin-left: 20px;
                }
            }
        }
    }

    .model-house {
        .top {
            color: #000;

            h1 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 2px;
            }
        }

        .bottom {
            display: flex;
            align-items: center;

            .leftElement {
                display: flex;
                align-items: center;
                flex: 1;
                flex-wrap: nowrap;

                .pIcon {
                    width: 11%;
                    height: auto;
                }

                .remainingPoints {
                    margin-left: 1%;
                }

                .pointData {
                    font-size: 18px;
                    color: #015C61;
                    font-weight: bold;
                    margin-left: 2%;
                }

                .specialWord {
                    color: #7101ad;
                }
            }
        }
    }
}


.user-detail-info {
    margin-top: 20px;

    /deep/ .ant-tag {
        margin-bottom: 8px;
    }
}

//彈出框
.package-modal-box {
    .lists {
        display: flex;
        align-items: center;
        padding: 20px;
        border: 1px solid #eee;
        border-radius: 5px;
        margin-bottom: 15px;
        background-color: #f9f9f9;
        transition: all .3s ease;

        &:hover {
            border-color: #dedede;
            box-shadow: 0 0 8px 5px rgba(0, 0, 0, .05);
        }

        &:last-child {
            margin-bottom: 0;
        }

        .icon-box {
            width: 100px;
            height: 100px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-right: 15px;



            h1 {
                font-size: 18px;
                color: #fff;
                margin-bottom: 0;
            }

            span {
                display: inline-block;
                width: 50px;
                height: 1px;
                border-bottom: 1px dotted #fff;
                margin-bottom: 5px;
                margin-top: 5px;
            }

            h5 {
                font-size: 12px;
                color: #fff;
                margin-bottom: 0;
            }
        }

        .info-box {
            flex: 1;

            .pIcon {
                width: 10%;
                height: auto;
                margin: 0 1% 2% 0;
            }

            .title {
                font-size: 18px;
                color: #000;
                display: inline-block;
            }

            .info {
                color: #aaa;
            }

            p {
                font-size: 18px;
                color: #000;
                margin-bottom: 0;

                .sm-text {
                    font-size: 14px;
                    color: #aaa;
                }
            }
        }

        .emendation-box {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            margin-right: 20px;
            margin-left: 20px;

            .btns {
                width: 30px;
                height: 30px;
                border: 1px solid #eee;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: #999;
                line-height: normal;
                background-color: #f9f9f9;
                cursor: pointer;
            }

            .nums {
                width: 40px;
                height: 30px;
                border-bottom: 1px solid #eee;
                border-top: 1px solid #eee;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .btns-box {
            flex-shrink: 0;

            .specialBtn {
                background-color: #7101ad;
                border-color: #7101ad;
            }
        }
    }
}

//支付
.pay-wrap {
    .top {
        display: flex;
        align-items: center;
        padding: 20px;
        background-color: #f7f7f7;
        border-radius: 10px;
        border: 1px dashed #dedede;

        .icon-box {
            width: 80px;
            height: 80px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-right: 15px;

            h1 {
                font-size: 16px;
                color: #fff;
                margin-bottom: 0;
            }

            span {
                display: inline-block;
                width: 50px;
                height: 1px;
                border-bottom: 1px dotted #fff;
                margin-bottom: 5px;
                margin-top: 5px;
            }

            h5 {
                font-size: 12px;
                color: #fff;
                margin-bottom: 0;
            }
        }

        .info-box {
            flex: 1;

            .pIcon {
                width: 7%;
                height: auto;
                margin: 0 1% 1% 0;
            }

            h1 {
                font-size: 18px;
                color: #000;
                display: inline-flex;
            }

            h5 {
                color: #aaa;
            }
        }

        .other-btn {
            flex-shrink: 0;
            color: #fff;
            border-radius: 20px;
            cursor: pointer;
            padding: 8px 15px;
            font-size: 12px;
            background-color: #f6732c;
        }
    }

    .amount-box {
        font-size: 16px;
        color: #000;
        text-align: center;
        padding: 30px 0;

        .amounts {
            color: #be4242;
            margin: 0 8px;
        }
    }

    .contents-box {
        margin-top: 20px;

        .pay-title {
            font-size: 16px;
            color: #000;
            margin-bottom: 15px;

            .anticon {
                margin-right: 10px;
            }
        }

        .pay-type-list {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-radius: 5px;
            border: 1px solid #dedede;
            margin-bottom: 20px;
            cursor: pointer;

            &.active {
                background-color: rgba(13, 149, 232, .1);
                border-color: rgba(13, 149, 232, .5);
                color: #0d95e8;
            }

            .texts {
                font-size: 12px;
                color: #aaa;
                margin-left: 5px;
            }

            .btns {
                font-size: 12px;
                display: inline-block;
                background-color: #0d95e8;
                color: #fff;
                height: 22px;
                line-height: 22px;
                border-radius: 11px;
                padding: 0 10px;
                margin-left: 10px;
            }
        }

        .ant-form {
            padding: 20px 20px 1px 20px;
            background-color: #f5f5f5;

        }

        &.last-step {
            padding: 50px 0;

            .amount-boxs {
                text-align: center;
                font-size: 18px;

                .amount {
                    color: #be4242;
                    margin: 0 5px;
                }

                margin-bottom: 40px;
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: center;

                .pay-btn {
                    margin-left: 20px;
                }
            }
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;

        .amount {
            color: #be4242;
            margin: 0 8px;
        }

        .btns {
            display: flex;
            align-items: center;

            .ant-btn:last-child {
                margin-left: 20px;
            }
        }
    }
}

//支付結果
.pay-result-box {
    padding: 50px 0 40px 0;

    .content {
        text-align: center;
        margin-bottom: 30px;
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: center;

        .ant-btn:last-child {
            margin-left: 20px;
        }
    }

    .tips {
        text-align: center;
        font-size: 12px;
        color: #999;
        padding-top: 10px;
    }
}
</style>
